import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui';
import HelpIcon from '@mui/icons-material/Help';

// A real Tooltip (rather than a hand-rolled hover-only Popover) so this opens on keyboard
// focus as well as mouse hover, and is linked to the icon via aria-describedby automatically.
const FieldHelpIcon = ({ children }) => (
  <Tooltip title={children} lightTooltip>
    <HelpIcon
      aria-hidden={false}
      htmlColor="#999999"
      style={{ fontSize: '1rem', paddingLeft: '0.5rem' }}
      tabIndex={0}
    />
  </Tooltip>
);

FieldHelpIcon.propTypes = {
  children: PropTypes.node
};

export default FieldHelpIcon;
